/** Help Center search results for a query, memoised over one shared index. */
import { useMemo } from 'react';
import { HELP_CENTER } from '@/content/help';
import { createSearchIndex, searchHelp } from '@/content/help/search';

let sharedIndex = null;
function getIndex() {
  if (!sharedIndex) sharedIndex = createSearchIndex(HELP_CENTER.articles);
  return sharedIndex;
}

export function useHelpSearch(query, limit = 20) {
  return useMemo(() => (query.trim() ? searchHelp(getIndex(), query, { limit }) : []), [query, limit]);
}
